module.exports = __webpack_public_path__ + "static/media/bookgroup_add.feb8695e.png";